import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-administrateur',
  templateUrl: './home-administrateur.component.html',
  styleUrls: ['./home-administrateur.component.scss']
})
export class HomeAdministrateurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
